import { render, staticRenderFns } from "./ChooseCampusPage.vue?vue&type=template&id=c315b65e&scoped=true&"
import script from "./ChooseCampusPage.vue?vue&type=script&lang=js&"
export * from "./ChooseCampusPage.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCampusPage.vue?vue&type=style&index=0&id=c315b65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c315b65e",
  null
  
)

export default component.exports